import React from 'react';
import MoneyTextField from 'common/components/MoneyTextField';
import { useSelector } from 'react-redux';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { useTranslation } from 'services/localization';

interface Props {
	value: number | undefined;
	onChange: (value: number) => void;
	disabled?: boolean;
}
const DepositInput = (props: Props) => {
	const { t } = useTranslation();
	const { value, onChange, disabled } = props;

	const currency = useSelector(ShopSelectors.getShopCurrency);
	const defaultVat = useSelector(ShopSelectors.activeShopDefaultVat);

	return (
		<MoneyTextField
			currency={currency}
			value={value ?? 0}
			useMinorUnits
			onValueChange={onChange}
			variant="outlined"
			helperText={t('product.depositSection.defaultVatNote', {
				defaultVat: defaultVat,
				defaultValue: 'Deposit will use the default VAT of the shop - currently {{defaultVat}}%',
			})}
			disabled={disabled}
			placeholder={t('product.depositSection.noDeposit', 'No deposit')}
			fullWidth
		/>
	);
};

export default DepositInput;
